import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

import { AggregationSevice } from 'src/app/shared/preaggregation/aggregation-service';
import { ProjectService } from 'src/app/shared/project/project.service';
import { BaseColumnSelectComponent } from '../column-types/base-column-selection.component';
import { ImportStep } from '../import-step';
import { UIFormCompAggregationSettingsItem, UIAggregationSettings } from 'src/app/shared/preaggregation/aggregation-settings';
import { UIAggregationMethod, UIAggregationType, AggregationMethod } from 'src/app/shared/preaggregation/aggregation-method';
import { ColumnName } from 'src/app/shared/import/column-name';
import { DataService } from 'src/app/shared/network/data.service';
import { AggregationSettingsHelper } from 'src/app/shared/preaggregation/aggregation-settings-helper';

@Component({
    selector: 'aggregation-settings',
    templateUrl: './aggregation-settings.component.html',
    styleUrls: ['../general.scss', '../column-types/column-selection.scss']
})
export class AggregationSettingsComponent extends BaseColumnSelectComponent implements OnInit {
    readonly step = ImportStep.AggregationSettings;
    UIAggregationType: typeof UIAggregationType = UIAggregationType;   //hack for enum to be available in the template

    loading = false;
    dataLoaded = false;

    public formComps: UIFormCompAggregationSettingsItem[];
    public numericColumns: ColumnName[];
    public outcomeName: string;

    form = new FormGroup({
        strategy: new FormControl(),
    });

    constructor(private aggregationSevice: AggregationSevice, projectService: ProjectService, private dataService: DataService)  {
        super(projectService);
    }

    public async loadDataInternal(): Promise<void> {
        const res = await this.aggregationSevice.getAggregationSettings(this.projectId);
        const uiSettings = UIAggregationSettings.fromCore(res);
        this.stepState = uiSettings.stepState;
        this.formComps = uiSettings.formComps;
        this.numericColumns = uiSettings.numericColumns;
        this.outcomeName = uiSettings.outcomeName;
    }

    override ngOnInit(): void {
        super.ngOnInit();
    }

    override setActive(val: boolean): void {
        super.setActive(val);
    }

    public async save() {
        if (this.loading) {
            return;
        }
        try {
            const businessLogicMethods = this.formComps.map(fc => 
                UIAggregationMethod.toCore(fc.aggregationMethod)
            );
            
            const changesApplied = await this.dataService.post<boolean>('aggregation/saveSettings', {
                projectId: this.projectId,
                formulaComponentAggregationMethods: businessLogicMethods,
            });
            this.finishStepSuccessfully(changesApplied);
        } finally {
            this.loading = false;
        }
    }

    public onAggregationMethodChange(formComp: UIFormCompAggregationSettingsItem,  newValue: UIAggregationType) {
        AggregationSettingsHelper.onAggregationMethodChange(formComp, newValue);
    }

    public onColumnToAvgChange(aggrMethod: UIAggregationMethod): void {
        AggregationSettingsHelper.onColumnToAvgChange(aggrMethod, this.formComps);
    }

    public get summary() {
        if (!this.formComps) {
            return '';
        }

        return this.formComps.map(fc => fc.name + ': ' + this.getAggregationMethodStr(fc.aggregationMethod)).join(', ');
    }

    private getAggregationMethodStr(aggrMethod: UIAggregationMethod) {
        switch(aggrMethod.type) {
            case UIAggregationType.sum:
                return 'sum';
            case UIAggregationType.averageSomehow:
                // Check if columnIndex is set to determine the display text
                if (Number.isInteger(aggrMethod.columnIndex)) {
                    return 'average on ' + this.numericColumns.find(nc => nc.index == aggrMethod.columnIndex).name;
                } else {
                    return 'average';
                }
        }
    }
}
